import { makeAutoObservable, observable, computed, action, runInAction } from "mobx";
import {
  IUser,
  IUserFormValues,
  IUserResetPassword,
  IUserChangePassword,
} from "../models/user";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { history } from "../..";
import { showError } from "../util/errorTypeEnumsOptions";

export default class UserStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable user: IUser | null = null;

  @computed get isLoggedIn() {
    return !!this.user;
  }

  @action relogFromLogin = async () => {
    try {
      const us = await agent.User.relogUser();
      runInAction(() => {
        this.user = us;
        history.push("/home/Client/DashboardClient");
      });
    } catch (error) {}
  };

  @action logout = () => {
    this.rootStore.commonStore.setToken(null);
    this.user = null;
    this.rootStore.companyStore.image=null;
    this.rootStore.reportStore.clearFilters();
    history.push("/");
  };

  @action relogUsers = async () => {
    if (this.isLoggedIn) {
      return;
    }

    try {
      const us = await agent.User.relogUser();
      runInAction(() => {
        this.user = us;
      });
    } catch (error) {
      history.push("/");
    }
  };

  @action login = async (values: IUserFormValues) => {
    try {
      const user = await agent.User.login(values);
      runInAction(() => {
        this.user = user;
        this.rootStore.buttonLoadingStore.changeState();
      });
      this.rootStore.commonStore.setToken(user.token);
      this.rootStore.companyStore.getBroker();
      history.push("/home/Client/DashboardClient");
    } catch (error) {
      if (error.response.data.ErrorCode === 1301)
        toast.error("Usuario o contraseña incorrectos");
      else showError(error);
      this.rootStore.buttonLoadingStore.changeState();
    }
  };

  @action changePassword = async (values: IUserChangePassword) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const cambio = await agent.User.changePassword(values);
      if (cambio) {
        toast.success("Tu contraseña se ha cambiado correctamente");
        this.rootStore.modalStore.closeModal();
      } else {
        toast.error(
          "UPS! Ocurrio un error cambiando la contraseña, vuelve a intentarlo más tarde"
        );
      }
    } catch (error) {
      if (error.response.data.ErrorCode === 1301)
        toast.error("Contraseña anterior invalida");
      else showError(error);
      this.rootStore.buttonLoadingStore.changeState();
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action editUser = async (id: any, values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const user = await agent.User.editUser(id, values);
      runInAction(() => {
        this.user = user;
      });
      toast.success("Tu usuario se ha actualizado correctamente");
      this.rootStore.modalStore.closeModal();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action sendReset = async (value: string) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const emailSend = await agent.User.sendReset(value);
      toast.success("Se ha enviado un correo a " + emailSend);
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action resetPassword = async (values: IUserResetPassword, token: string) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const cambio = await agent.User.resetPassword(values, token);
      if (cambio) {
        toast.success("Tu contraseña se ha establecido correctamente");
        history.push("/");
      } else {
        toast.error(
          "UPS! Ocurrio un error estableciendo la contraseña, vuelve a intentarlo más tarde"
        );
      }
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };
}
